module.exports = __webpack_public_path__ + "assets/img/kv-6235c6b6.jpg";